export enum ELandingType {
  Unexpected = 'unexpected',
  JoinOtaCian = 'joinOtaCian',
  JoinOtaLegalShort = 'joinOtaLegalShort',
  ActivateInsurance = 'activateInsurance',
  Megalanding = 'megalanding',
  BusinessEntityFlow = 'businessEntityFlow',
  SurchargePerGuest = 'surchargePerGuest',
  UpdateMobileApp = 'updateMobileApp',
  OnlineBookingProfile = 'onlineBookingProfile',
}
